import throttle from 'lodash.throttle';
import PropTypes from 'prop-types';
import React, { createContext, useEffect, useRef, useState } from 'react';

export const Context = createContext(false);

const isHomeCheck = pathname => pathname === '/';

export default function NavigationContext({ children, pathname }) {
  const [isFixed, setIsFixed] = useState(false);
  const [isHome, setIsHome] = useState(isHomeCheck(pathname));
  const headerRef = useRef(null);

  function handleScroll(evt) {
    if (evt?.target?.scrollingElement?.scrollTop > 20 && !isFixed) {
      if (headerRef.current) {
        headerRef.current.classList.add('fixed');
      }
      setIsFixed(true);
    } else if (evt?.target?.scrollingElement?.scrollTop < 20) {
      if (headerRef.current) {
        headerRef.current.classList.remove('fixed');
      }
      setIsFixed(false);
    }
  }

  const throttledScroll = throttle(handleScroll, 20);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      document.addEventListener('scroll', throttledScroll);
    }

    return () => {
      document.removeEventListener('scroll', throttledScroll);
    };
  }, [throttledScroll]);

  useEffect(() => {
    setIsHome(isHomeCheck(pathname));
  }, [pathname]);

  return (
    <Context.Provider
      value={{
        isFixed,
        isHome,
        isHomeAndFixed: isHome && isFixed,
        isHomeAndNotFixed: isHome && !isFixed,
        isNotHomeAndFixed: !isHome && isFixed,
        isNotHomeAndNotFixed: !isHome && !isFixed,
        ref: headerRef,
      }}
    >
      {children}
    </Context.Provider>
  );
}

NavigationContext.propTypes = {
  children: PropTypes.node.isRequired,
  pathname: PropTypes.string.isRequired,
};
